// Use dynamic import to properly handle module federation async loading
import('./bootstrap').catch((err) => console.error('Error loading bootstrap:', err));
